import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Carousel from 'modules/Carousel';
import WhySquareboard from 'modules/WhySquareboard';
import Environment from 'modules/Environment';
import Offers from 'modules/Offers';
import Pricing from 'modules/Pricing';
import Trust from 'modules/Trust';
import AboutUs from 'modules/AboutUs';

class LandingPageView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return [
      <Carousel />,
      <WhySquareboard />,
      <Environment />,
      <Offers />,
      <Pricing key="pricing" {...this.props} />,
      <Trust />,
      <AboutUs />,
    ];
  }
}

export default LandingPageView;
